import FileSaver from 'file-saver';
import { actions as jobActions } from '@saucelabs/sl-module-jobs';

import { actions, constants } from '.';


export const fetchAndDisplayFile = ({
  availableFiles, auth, jobId, assetName, config,
}) => (dispatch) => {
  dispatch(actions.selectFile(assetName));
  dispatch(actions.showLoader());

  const fileAlreadyDownloaded = availableFiles.get(assetName);


  if (fileAlreadyDownloaded) {
    return dispatch(actions.attachFile({ name: assetName, data: fileAlreadyDownloaded.data }));
  }

  const assetFetchMethod = constants.EDS_SPECIFIC_FILENAMES.includes(assetName) ?
    jobActions.getEdsAsset.bind(jobActions.getEdsAsset) :
    jobActions.getAsset.bind(jobActions.getAsset);

  return dispatch(assetFetchMethod({ id: jobId, auth, assetName, config }, { skipErrorPage: true }))
    .then(({ data }) => dispatch(actions.attachFile({ name: assetName, data })))
    .catch(() => null);
};

export const getBlobFile = ({ assetName, auth, jobId }) => (dispatch) => {
  const axiosOptions = {
    id: jobId,
    assetName,
    auth,
    params: {
      responseType: 'blob',
    },
    config: {
      transformResponse: (raw) => raw,
    },
  };

  return dispatch(jobActions.getAsset(axiosOptions, { skipErrorPage: true }))
    .then((response) => {
      FileSaver.saveAs(new Blob([response.data]), assetName);
    });
};
